import { clsx } from 'clsx';
import { phoneFormatter } from '@utils';
import { makeStyles } from '@mui/styles';
import MaskedInput from 'antd-mask-input';
import { TextInputProps } from 'react-admin';
import { useController } from 'react-hook-form';
import React, { SyntheticEvent, useEffect } from 'react';
import { PasswordInput } from 'ra-ui-materialui';

interface Props {
  valueFormat?: 'masked' | 'unmasked';
  className?: string;
  isHidden?: boolean;
}

export const PhoneMaskedInput = (props: TextInputProps & Props) => {
  const cls = useStyles();
  const [error, setError] = React.useState(false);
  const source = props.source;
  const {
    field: { value, onChange },
    formState: { errors },
  } = useController({ name: source });
  const errorMessage = (errors[source]?.message as any)?.message;

  useEffect(() => {
    if (errorMessage) {
      setError(true);
    }
  }, [errorMessage]);

  const handleChange = (
    e: SyntheticEvent & {maskedValue: string; unmaskedValue: string},
  ): any => {
    if (e.unmaskedValue.length === 10) {
      const result = props.valueFormat === 'masked' || !props.valueFormat
        ? e.maskedValue
        : `+52${e.unmaskedValue}`;
      onChange(result);
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <div className={props.className}>
      <label className={cls.label}>
        <span>{props.label}</span>
      </label>
      <div className={clsx('MuiInputBase-root', cls.box)}>
        {props.isHidden ? (
          <PasswordInput
            source={source}
            className={clsx('hide-eye', cls.inputField, cls.passwordInput, error && cls.error)}
            disabled={props.disabled}
            label={false}
          />
        ) : (
          <MaskedInput
            mask={'+52 (000) 000-0000'}
            className={clsx('phone-input', cls.inputField, error && cls.error)}
            value={phoneFormatter.format(value)}
            onChange={handleChange}
            disabled={props.disabled}
          />
        )}
        {errorMessage && <div className={cls.errorMessage}>{errorMessage}</div>}
      </div>
    </div>
  );
};

const useStyles = makeStyles({
  label: {
    display: 'block',
    color: 'var(--primary-color)',
    fontSize: 12,
    lineHeight: 1,
    marginTop: 4,
    marginLeft: 14,
    marginBottom: 3,
  },
  box: {
    overflow: 'hidden',
  },
  inputField: {
    fontSize: 16,
    padding: 0,
    border: 0,
    borderBottom: '1px solid var(--logo-color) !important',
    boxShadow: 'none',
    background: 'none',
    color: 'var(--text-color)',
    '&[disabled]': {
      background: 'none',
      color: 'var(--text-color)',
    },
    width: '100%',
    '& > div': {
      backgroundColor: 'transparent !important',
      height: '24px !important',
    },
  },
  passwordInput: {
    width: '100% !important',
    '& > div': {
      backgroundColor: 'transparent !important',
    },
    '& input': {
      padding: '0 !important',
    },
  },
  error: {
    borderBottom: '1px solid red !important',
  },
  errorMessage: {
    fontSize: 10,
    color: 'red',
    lineHeight: 1,
    fontWeight: 500,
  },
});
